import Dropdown from "./DropdownNew";
import dropdownIcon from "../img/svg/dropdown_icon.svg";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const CustomSearch = ({
  cityOptions = [],
  clubOptions = [],
  categoryOptions = [],
  onCitySelect,
  onClubSelect,
  onCategorySelect,
}) => {
  const { t } = useTranslation();
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedClub, setSelectedClub] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleSearchClick = () => {
    onCitySelect(selectedCity || "");
    onClubSelect(selectedClub || "");
    onCategorySelect(selectedCategory || "");
  };

  return (
    <div className="fit-extend-selector-dropdowns-container">
      <Dropdown
        options={cityOptions}
        onSelect={(value) => setSelectedCity(value)}
        imgUrl={dropdownIcon}
        placeholder={t("SELECT_SEARCH_CITY")}
      />
      <Dropdown
        options={categoryOptions}
        onSelect={(value) => setSelectedCategory(value)}
        imgUrl={dropdownIcon}
        isShouldRotate={true}
        placeholder={t("SEARCH_BY_CATEGORY")}
      />
      <Dropdown
        options={clubOptions}
        onSelect={(value) => setSelectedClub(value)}
        imgUrl={dropdownIcon}
        isShouldRotate={true}
        placeholder={t("SELECT_SEARCH_CLUB")}
      />
      <button className="custom-search-btn" onClick={handleSearchClick}>
        {t("SEARCH")}
      </button>
    </div>
  );
};

export default CustomSearch;
